import { Component } from 'react';

export class ErrorStatusOutlineSVG extends Component<{
    className?: string;
    fill?: string;
    stroke?: string;
    transform?: string;
    'data-testid': string;
}> {
    render() {
        const { className, fill, stroke, transform } = this.props;

        return (
            <svg
                className={className}
                data-testid={this.props['data-testid']}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                transform={transform ? transform : 'none'}
            >
                <path
                    d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                    stroke={stroke ? stroke : '#2B4959'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10.5523 5 11 5.44772 11 6V12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12L9 6C9 5.44772 9.44772 5 10 5ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16Z"
                    fill={fill ? fill : '#2B4959'}
                />
            </svg>
        );
    }
}
